import * as modelHelper from "../helpers/modelHelper";

/**
 * @class PluginManager
 */
export default class PluginManager {
    /**
     * @param {Object}  configuration
     */
    constructor(configuration) {
        let winterTime = this.isWinterTime();

        if (typeof configuration === "object" && configuration !== null) {
            try {
                this._loyaltyCards = configuration.loyaltyCards !== undefined;

                let winterConfig = configuration.winter === undefined || configuration.winter;

                this._winter = {
                    active: winterTime && winterConfig,
                    config: winterConfig,
                    winterTime: winterTime
                };
            } catch (e) {
                this._loyaltyCards = false;
                this._winter = {
                    active: false,
                    config: false,
                    winterTime: winterTime
                };
            }
        } else {
            this._loyaltyCards = false;
            this._winter = {
                active: winterTime,
                config: true,
                winterTime: winterTime
            };
        }
    }

    /**
     * @return {Boolean}
     */
    get loyaltyCards() {
        return this._loyaltyCards;
    }

    /**
     * @return {Boolean}
     */
    get winter() {
        return this._winter.active;
    }

    /**
     * @return {Boolean}
     */
    get winterConfig() {
        return this._winter.config;
    }

    /**
     * @return {Boolean}
     */
    get winterTime() {
        return this._winter.winterTime;
    }

    /**
     * @return {Object}
     */
    clone() {
        let clone = new PluginManager();
        clone._loyaltyCards = this._loyaltyCards;
        clone._winter = modelHelper.clone(this._winter);

        return clone;
    }

    /**
     * Checks winter time.
     *
     * @return  {Object}
     */
    isWinterTime = () => {
        let date = new Date();

        return date.getMonth() === 11 && date.getDate() > 15;
    };

    /**
     * Clones PluginManager object and updates winter plugin.
     *
     * @param   {Boolean} config
     * @return  {Object}
     */
    updateWinterPlugin = (config) => {
        let pluginManager = this.clone();
        pluginManager._winter.active = pluginManager._winter.winterTime && config;
        pluginManager._winter.config = config;

        return pluginManager;
    };

    /**
     * Clones PluginManager object and updates winter time for winter plugin.
     *
     * @return  {Object}
     */
    updateWinterTimePlugin = () => {
        let winterTime = this.isWinterTime();

        if (winterTime === this._winter.winterTime) {
            return this;
        }

        let pluginManager = this.clone();
        pluginManager._winter.active = winterTime && pluginManager._winter.config;
        pluginManager._winter.winterTime = winterTime;

        return pluginManager;
    };
}
